import { render, staticRenderFns } from "./ReleasedPayment.vue?vue&type=template&id=aff64858&"
import script from "./ReleasedPayment.vue?vue&type=script&lang=js&"
export * from "./ReleasedPayment.vue?vue&type=script&lang=js&"
import style0 from "./ReleasedPayment.vue?vue&type=style&index=0&id=aff64858&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports